import { createReducer, on } from '@ngrx/store';
import { setprojectDetailsPONumber, clearprojectDetailsPONumber } from './projectDetailsPONumber.action';
import { initialprojectDetailsPONumberState } from './projectDetailsPONumber.state';

export const projectDetailsPONumberReducer = createReducer(
  initialprojectDetailsPONumberState,
  on(setprojectDetailsPONumber, (state, { projectDetailsPONumber }) => ({ ...state, projectDetailsPONumber : projectDetailsPONumber })),
  on(clearprojectDetailsPONumber, state => ({ ...state, projectDetailsPONumber : null }))
);
